exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-table[data-v-01a9c3c7]  .el-loading-mask{background-color:hsla(0,0%,100%,.6)}.common-table[data-v-01a9c3c7]  .el-loading-spinner .path{stroke:#2675f1}.common-table.el-table[data-v-01a9c3c7]  td{color:inherit}", ""]);

// exports
